/**
 * @generated SignedSource<<72f7b0a2634066b106d7e4746a95bd51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Plan = "FREE" | "PRO" | "PROMO" | "STARTER" | "UP_TO_100" | "UP_TO_15" | "UP_TO_200" | "UP_TO_30" | "UP_TO_5" | "UP_TO_50" | "UP_TO_75" | "UP_TO_INFINITY" | "UP_TO_UNLIMITED" | "YEARLY_UNLIMITED" | "YEARLY_UP_TO_100" | "YEARLY_UP_TO_200" | "YEARLY_UP_TO_50" | "%future added value";
export type EnterInviteCodeQuery$variables = {
  code: string;
};
export type EnterInviteCodeQuery$data = {
  readonly inviteCode: {
    readonly coach: {
      readonly clientsCountNoSample: number;
      readonly plan: Plan | null | undefined;
    };
    readonly id: string;
  } | null | undefined;
};
export type EnterInviteCodeQuery = {
  response: EnterInviteCodeQuery$data;
  variables: EnterInviteCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": "clientsCountNoSample",
  "args": [
    {
      "kind": "Literal",
      "name": "noSample",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "clientsCount",
  "storageKey": "clientsCount(noSample:true)"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plan",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnterInviteCodeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InviteCode",
        "kind": "LinkedField",
        "name": "inviteCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "coach",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnterInviteCodeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InviteCode",
        "kind": "LinkedField",
        "name": "inviteCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "coach",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "461ca63a42d68d3a04527d8a40747bae",
    "id": null,
    "metadata": {},
    "name": "EnterInviteCodeQuery",
    "operationKind": "query",
    "text": "query EnterInviteCodeQuery(\n  $code: String!\n) {\n  inviteCode(code: $code) {\n    id\n    coach {\n      clientsCountNoSample: clientsCount(noSample: true)\n      plan\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef45774a84ae13b5a2dd2e1bf67eec9c";

export default node;
